import classNames from "classnames";
import React, { PropsWithChildren } from "react";

interface Props {
  className?: string;
}

const ModalActions = (props: PropsWithChildren<Props>) => {
  return <div className={classNames("ModalActions", props.className)}>{props.children}</div>;
};

export default ModalActions;
